// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-templates-nearme-page-dumpster-js": () => import("./../../../src/templates/nearme-page-dumpster.js" /* webpackChunkName: "component---src-templates-nearme-page-dumpster-js" */),
  "component---src-templates-search-apollo-js": () => import("./../../../src/templates/search-apollo.js" /* webpackChunkName: "component---src-templates-search-apollo-js" */)
}

